import { css } from '@emotion/react';
import { ButtonBase, CircularProgress } from '@mui/material';

import { Text } from '~/components/ui/text';
import { DownloadQrImageFormat } from '~/types/qrCode';

type DownloadQRTypeButtonProps = {
  icon: JSX.Element;
  text: string;
  type: DownloadQrImageFormat;
  isLoading: boolean;
  onClick: () => void;
};

export default function DownloadQRTypeButton({ icon, type, text, isLoading, onClick }: DownloadQRTypeButtonProps) {
  const styles = useStyles();

  return (
    <ButtonBase sx={styles.downloadBtn} onClick={onClick}>
      {isLoading ? (
        <CircularProgress size={52} />
      ) : (
        <>
          <Text variant="t18Medium" sx={styles.imageText}>
            {icon} {type}
          </Text>
          <Text variant="button14Med" sx={{ color: 'var(--grey400)' }}>
            {text}
          </Text>
        </>
      )}
    </ButtonBase>
  );
}

function useStyles() {
  return {
    downloadBtn: css`
      display: flex;
      flex-direction: column;
      border: 1px solid var(--grey200);
      padding: 8px;
      border-radius: 20px;
      gap: 4px;

    '&:hover': {
        background: radial-gradient(7564.65% 631.25% at 50.09% 50%, #0487e600 0%, #0487E6 100%);
        border: 1px solid var(--primary);
        box-shadow: 0 0 0 1px var(--primary);
      },
    `,
    imageText: css`
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      text-transform: uppercase;
    `,
  };
}
